import baseConfig from '@config/baseConfig';

const phaserConfig = baseConfig();

export const config = {
  width: phaserConfig.width,
  height: phaserConfig.height,
  audio: {
    bgaudio: null,
    caraudio: null,
    hintaudio: null,
    incorrectaudio: null,
    correctaudio: null,
    lanechangeaudio: null,
    yayaudio: null,
  },
};

export const gameState = {
  score: 0,
  attempted: 0,
  hints: 0,
  questionNumber: 0,
  gameWin: false,
};
